import { createSelector } from '@reduxjs/toolkit';

import { CompPropertyDataState } from '../../../types.ts';
import { selectHasArvOption } from '../orderSelectors.ts';
import { selectAivArvActiveTab } from '../uiSelectors.ts';
import { selectPropertyDataEntities } from './propertyDataSelectors.ts';

export const selectPropertyDataCompTypes = createSelector(
  [selectPropertyDataEntities],
  (propertyDataEntities) => {
    const compTypes: Record<string, string | undefined> = {};
    Object.values(propertyDataEntities).forEach((propertyData) => {
      if (!propertyData) return;
      if (propertyData.id === 'subject') return;

      const compData = propertyData as CompPropertyDataState;
      compTypes[compData.id] = compData.compData?.compType;
    });

    return compTypes;
  },
);

export const selectCompTypeVisibility = createSelector(
  [selectAivArvActiveTab, selectHasArvOption],
  (aivArvActiveTab, hasArvOption) => ({
    showAivComps: !hasArvOption || aivArvActiveTab === 'all' || aivArvActiveTab === 'aiv',
    showArvComps: !hasArvOption || aivArvActiveTab === 'all' || aivArvActiveTab === 'arv',
  }),
);
